import { render, staticRenderFns } from "./popupTips.vue?vue&type=template&id=7ca1e8ae&scoped=true"
import script from "./popupTips.vue?vue&type=script&lang=js"
export * from "./popupTips.vue?vue&type=script&lang=js"
import style0 from "./popupTips.vue?vue&type=style&index=0&id=7ca1e8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1e8ae",
  null
  
)

export default component.exports